export enum BusinessObjectsCover {
  NATURAL_EVENTS = 'NATURAL_EVENTS',
  WATER_DAMAGE = 'WATER_DAMAGE',
  ROBBERY = 'ROBBERY',
  GLASS_BREAKAGE = 'GLASS_BREAKAGE',
  OPERATING_LOSS = 'OPERATING_LOSS',
  HYGIENE = 'HYGIENE',
  CYBER = 'CYBER',
  EARTHQUAKE = 'EARTHQUAKE',
  TRANSPORT = 'TRANSPORT',
  MACHINERY = 'MACHINERY',
  EPIDEMIC = 'EPIDEMIC',
}

export const getBusinessObjectsCoverLabel = (cover: BusinessObjectsCover) => {
  switch (cover) {
    case BusinessObjectsCover.NATURAL_EVENTS:
      return $localize`Événements naturels`;
    case BusinessObjectsCover.WATER_DAMAGE:
      return $localize`Dégâts d'eau`;
    case BusinessObjectsCover.ROBBERY:
      return $localize`Vol`;
    case BusinessObjectsCover.GLASS_BREAKAGE:
      return $localize`Bris de glace`;
    case BusinessObjectsCover.OPERATING_LOSS:
      return $localize`Perte d'exploitation`;
    case BusinessObjectsCover.HYGIENE:
      return $localize`Hygiène`;
    case BusinessObjectsCover.CYBER:
      return $localize`Cyber risques`;
    case BusinessObjectsCover.EARTHQUAKE:
      return $localize`Tremblement de terre`;
    case BusinessObjectsCover.TRANSPORT:
      return $localize`Transport`;
    case BusinessObjectsCover.MACHINERY:
      return $localize`Bris de machines`;
    case BusinessObjectsCover.EPIDEMIC:
      return $localize`Épidémie`;
    default:
      return '';
  }
};
